export class EventEmitter {
    constructor(events) {
        this.events = events || {};
    }
    on(name, callback) {
        (this.events[name] || (this.events[name] = [])).push(callback);
    }
    emit(name, params) {
        (this.events[name] || []).forEach((fn) => fn(params));
    }
}
